export default "__VITE_ASSET__jdZISt1z__"